import * as React from 'react';
import { iconColors } from '@workday/canvas-kit-react/tokens';
import { CanvasIconTypes } from '@workday/design-assets-types';
import { Icon } from './Icon';
import { createComponent, getColor } from '@workday/canvas-kit-react/common';
export const systemIconStyles = ({ accent, accentHover, background = 'transparent', backgroundHover = 'transparent', color = iconColors.standard, colorHover = iconColors.hover, fill, fillHover, }) => ({
    '& .wd-icon-fill': {
        fill: getColor(fill) || getColor(color),
    },
    ':hover .wd-icon-fill': {
        fill: getColor(fillHover) || getColor(colorHover),
    },
    '& .wd-icon-accent, & .wd-icon-accent2': {
        fill: getColor(accent) || getColor(color),
    },
    ':hover .wd-icon-accent, :hover .wd-icon-accent2': {
        fill: getColor(accentHover) || getColor(colorHover),
    },
    '& .wd-icon-background': {
        fill: getColor(background),
    },
    ':hover .wd-icon-background': {
        fill: getColor(backgroundHover),
    },
});
export const SystemIcon = createComponent('span')({
    displayName: 'SystemIcon',
    Component: ({ background = 'transparent', backgroundHover = 'transparent', color = iconColors.standard, colorHover = iconColors.hover, icon, accent, accentHover, fill, fillHover, size, shouldMirror, ...elemProps }, ref, Element) => {
        const style = systemIconStyles({
            accent,
            accentHover,
            background,
            backgroundHover,
            color,
            colorHover,
            fill,
            fillHover,
        });
        return (React.createElement(Icon, Object.assign({ src: icon, type: CanvasIconTypes.System, size: size, as: Element, shouldMirror: shouldMirror, ref: ref, styles: style }, elemProps)));
    },
});
